import {
    GET_REFRESH_PURCHASE_ORDER, 
    SET_REFRESH_PURCHASE_ORDER,
    GET_PO_PDF_LINK_PONUMBER,
    SET_PO_PDF_LINK_PONUMBER
} from "./FleetRefreshPurchaseOrderType"

const getRefreshPurchaseOrder = (payload: any) => ({
    type: GET_REFRESH_PURCHASE_ORDER,
    payload
})

const setIsPurchaseOrderRefreshed = (isPurchaseOrderRefreshed: any) => ({
    type: SET_REFRESH_PURCHASE_ORDER,
    isPurchaseOrderRefreshed: isPurchaseOrderRefreshed
})

const getPoPdfLinkByPONumber = (payload: any) => ({
    type: GET_PO_PDF_LINK_PONUMBER,
    payload
})

const setPoPdfLinkByPONumber = (poPdfLinkByPONumber: any) => ({
    type: SET_PO_PDF_LINK_PONUMBER,
    poPdfLinkByPONumber: poPdfLinkByPONumber
})

export {
    getRefreshPurchaseOrder,
    setIsPurchaseOrderRefreshed,
    getPoPdfLinkByPONumber,
    setPoPdfLinkByPONumber
}